// Wheels (product type RIMS — every SW and PDXX wheel) sell in sets of 4.
// The quantity boxes on the product and cart pages already carry
// min="4" step="4" for them, but the +/- buttons are the only thing that
// respects it: the product form is novalidate and posts by fetch, and the
// cart posts whatever is typed, so a typed "1" went straight to checkout
// (order #1308). This snaps any stepped quantity box to the nearest set
// (never below its min) when it changes, just before the product form
// submits, and on load for cart lines that are already off.
(function () {
  function snap(input) {
    var step = parseInt(input.getAttribute('step'), 10);
    if (!(step > 1)) return false;
    var min = parseInt(input.getAttribute('min'), 10) || step;
    var value = parseInt(input.value, 10) || 0;
    if (value <= 0 && input.name === 'updates[]') return false; // typing 0 removes the line
    var snapped = Math.max(min, Math.round(value / step) * step);
    if (snapped === value && String(value) === input.value) return false;
    input.value = snapped;
    return true;
  }

  function isQuantityBox(el) {
    return el && el.classList && el.classList.contains('quantity__input');
  }

  function note(input) {
    var line = input.dataset.index;
    var error = line && document.getElementById('Line-item-error-' + line);
    var text = error && error.querySelector('.cart-item__error-text');
    if (text) text.textContent = 'Wheels are sold in sets of 4 — quantity set to ' + input.value + '.';
  }

  // Capture phase: runs before the cart's own change listener reads the value.
  document.addEventListener('change', function (event) {
    if (isQuantityBox(event.target) && snap(event.target)) note(event.target);
  }, true);

  // Pressing Enter in the box can submit before change fires.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.elements) return;
    Array.prototype.forEach.call(form.elements, function (el) {
      if (el.name === 'quantity' && isQuantityBox(el)) snap(el);
    });
  }, true);

  // A cart line that got in some other way (an old tab, a /cart/add link):
  // fix it through the cart's normal update path so totals re-render.
  function fixCart() {
    document.querySelectorAll('cart-items .quantity__input[name="updates[]"]').forEach(function (input) {
      if (snap(input)) {
        input.dispatchEvent(new Event('change', { bubbles: true }));
        setTimeout(function () { note(input); }, 1500);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fixCart);
  else fixCart();
})();
